<template>
    <div id="myinfo-dob">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="dob"
          name          ="dob"
          type          ="text"
          :label        ="$t('regis-dob')"
          :placeholder  ="$t('regis-dob')"
          autocomplete  ="off"
          outline
          floating-label
          required
          :value        = "dob"
          v-show        ="isShow"
          :disabled    = "isDisabled"
          @change       ="onInput($event)"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      this.init()
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'dob'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setDob',
        'validateInput'
      ]),

      init(){
        const self = this;

        const initDob = self.dob.split("-").reverse().join("-");

        const moment= require('moment');
        const oldDob  = moment(new Date(initDob)).format('YYYY-MM-DD');
        const maxDate = moment().subtract(18, 'years').format('YYYY-MM-DD'); // MIN 18 y.o
        const maxYear = moment().subtract(18, 'years').year();
        const maxMonth = moment().subtract(18, 'years').month();

        let newDob = null;
        if(initDob == "01-01-1950" || initDob == "" /*|| initDob == #regDate */){
          newDob = null
        }else{
          //console.log(oldDob+" ### "+maxDate)
          if(oldDob > maxDate /*&& oldDob != #regDate */){ // UNDERAGE ( < 18 y.o)
            newDob = oldDob;
          }else{
            if(oldDob /* != #regDate */){
              newDob = oldDob
            }else{
              newDob = null
            }
            
          }
        }

        //console.log("new new dob : "+newDob)
        self.myinfoDobCalendar = self.$f7.calendar.create({
          inputEl: '#dob',
          openIn: 'popup',
          dateFormat: "dd-mm-yyyy",
          closeOnSelect: true,
          value: newDob == null ? null : [new Date(newDob)],
          //maxDate: new Date(maxDate),
          yearPickerMax: maxYear,
          disabled: function (date) {
              if (date > new Date(maxDate)) {
                  return true;
              }
              else {
                  return false;
              }
          },
          on: {
            open: function () {
              //console.log('Calendar open : '+self.myinfoDobCalendar.getValue())
              if(self.myinfoDobCalendar.getValue() == undefined){
                self.myinfoDobCalendar.setYearMonth(maxYear, maxMonth)
              }
            }
          }
        })
      },

      async onInput(e){
        await this.setDob(e.target.value);
        await this.validateInput(e.target);
        this.validateNextButton()
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>